import { CheckboxGroupButtons, FloatingFormItem } from '@/components/_common';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';
import GroupsInfiniteSelectField from '@/components/_common/GroupsInfiniteSelectField';
import { isAppPortocar } from '@/index';
import { Col, Collapse, Form, Row } from 'antd';
import React from 'react';

const ByMovimentsMoreOptions: React.FC = () => {
  const osTypeOptions = [
    {
      value: '2',
      label: 'Orçamento',
    },
    {
      value: '1',
      label: 'Garantia',
    },
    {
      value: '4',
      label: 'Retorno',
    },
    {
      value: '0',
      label: isAppPortocar ? 'Interna (Cortesia)' : 'Cortesia',
    },
    {
      value: '3',
      label: 'Perda Total',
    },
    {
      value: '5',
      label: 'Revisão',
    },
  ];

  return (
    <Collapse>
      <Collapse.Panel key={1} header="Mais opções">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item name="osType" label="Tipo" initialValue={'2'}>
              <CheckboxGroupButtons options={osTypeOptions} />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem name="employeesIds" label="Funcionários">
              <EmployeesInfiniteSelectField mode="multiple" allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem name="groupIds" label="Grupos">
              <GroupsInfiniteSelectField mode="multiple" />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse>
  );
};

export default ByMovimentsMoreOptions;
